import { render, staticRenderFns } from "./wpsSetting.vue?vue&type=template&id=30aac1a8&scoped=true&"
import script from "./wpsSetting.vue?vue&type=script&lang=js&"
export * from "./wpsSetting.vue?vue&type=script&lang=js&"
import style0 from "./wpsSetting.vue?vue&type=style&index=0&id=30aac1a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aac1a8",
  null
  
)

export default component.exports